import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import styled from "@emotion/styled";
import { FormHelperText, MenuItem, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles'; // Import useTheme hook

const StyledSelect = styled(Select)`
  && {
    background-color: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
    &:hover {
      box-shadow: none !important;
    },
  }
`;

const StyledMenuItem = styled(MenuItem)`
  && {
    &:hover {
      background-color: rgba(219, 219, 235, 0.04) !important;
    }

    &.Mui-selected {
      background-color: ${({ theme }) => theme.palette.primary.light} !important;
    }
  }
`;

const StyledPaper = styled(Paper)`
  && {
    background-color: ${({ theme }) => theme.palette.background.paper} !important;
    color: ${({ theme }) => theme.palette.text.primary} !important;
  }
`;

const CustomSelect = ({ value, label, onChange, children, name, error, helperText }) => {
    const theme = useTheme();
    const borderColor = theme.palette.border.primary;

    return (
        <FormControl fullWidth sx={{
            '& fieldset': {
                borderColor: borderColor,
            },
            '& .MuiInputBase-root,label': {
                color: theme.palette.primary.main,
            },
            '& svg': {
                fill: error ? theme.palette.error.main : theme.palette.primary.main,
            },
            '& .MuiMenu-list': {
                backgroundColor: theme.palette.background.paper,
            },
            "& fieldset:hover": {
                borderColor: theme.palette.primary.main,
            },
            '& .MuiOutlinedInput-root': {
                '&:hover': {
                    '& fieldset': {
                        borderColor: theme.palette.primary.main,
                    },
                },
            },
            '& .Mui-focused': {
                '& fieldset': {
                    borderColor: theme.palette.primary.main,
                },
            },
            '& .MuiFormLabel-root': {
                '&.Mui-focused': {
                    color: theme.palette.primary.main,
                    backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.secondary.light,  // Background color on focus
                },
                backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.secondary.light, 
            },

            "& input": {
                color: theme.palette.text.primary,
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "400",
                padding: "14px",
                backgroundColor: theme.palette.mode === 'dark' 
                    ? theme.palette.background.default 
                    : theme.palette.secondary.light, 
                borderRadius: '10px',
                '&[type=number]': {
                    '-moz-appearance': 'textfield',
                },
            },
            "& .Mui-disabled": {
                WebkitTextFillColor: theme.palette.text.disabled,
                '& fieldset': {
                    borderColor: theme.palette.grey[500],
                },
            },
            '& fieldset': {
                borderColor: theme.palette.border.primary,

            },
            "& .MuiFormLabel-root": {
                color: "#9797A91F",
                backgroundColor: theme.palette.mode === 'dark' ? "transparent" : theme.palette.secondary.light,
            },
            // Hover border color
            "& fieldset:hover": {
                borderColor: theme.palette.primary.main,
            },
            // Focused state (show border color when focused or touched)
            '& .MuiOutlinedInput-root': {
                borderRadius: "10px",
                '&:hover': {
                    '& fieldset': {
                        borderColor: theme.palette.primary.main,
                    },
                },
                '&.Mui-focused': {
                    '& fieldset': {
                        borderColor: theme.palette.primary.main,
                    },
                },
            },
            // Label color
            ".MuiInputLabel-shrink": {
                color: theme.palette.primary.main,
            },
            '& .MuiFormLabel-root': {
                color: theme.palette.primary.main,
                fontSize: "16px",
                lineHeight: "20px",
                '&.Mui-focused': {
                    color: theme.palette.primary.main,
                    fontSize: "16px",
                    lineHeight: "20px",
                },
            },
            // Icon color (for any adornments/icons)
            '& svg': {
                fill: theme.palette.primary.main,
            },
            '& .MuiMenu-list': {
                backgroundColor: theme.palette.background.paper,
            },
            '& .MuiSelect-select':{
                padding:"13px"
            }
        }}>
            <InputLabel id="demo-simple-select-label" error={error}>{label}</InputLabel>
            <StyledSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={value}
                label={label}
                name={name}
                error={error}
                onChange={onChange}
                MenuProps={{
                    PaperProps: {
                        component: StyledPaper,
                    },
                }}
            >
                {React.Children.map(children, (child) => (
                    <StyledMenuItem value={child.props.value}>
                        {child.props.children}
                    </StyledMenuItem>
                ))}
            </StyledSelect>
            <FormHelperText error={error}>{error && helperText}</FormHelperText>
        </FormControl>
    );
};

export default CustomSelect;
